import { render } from "./PublicShell.vue?vue&type=template&id=57a04807"
import script from "./PublicShell.vue?vue&type=script&lang=js"
export * from "./PublicShell.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__